import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { FormFieldModule } from '../../wrapper/form-field/form-field.component';
import { MatSliderChange, MatSliderModule } from '@angular/material/slider';
import { ReactiveFormsModule } from '@angular/forms';
import { CyTestDirective } from '@portal/directive';
import { MatIconModule } from '@angular/material/icon';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { NgxMaskModule } from 'ngx-mask';
import { InputNumberDirective } from '../../directive';

@Component({
  selector: 'portal-form-slider',
  standalone: true,
  imports: [MatSliderModule, ReactiveFormsModule, FormlyModule, CyTestDirective, MatIconModule, NgxMaskModule, InputNumberDirective],
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent extends FieldType<PortalFieldTypeConfig> {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  protected increase(): void {
    const { value, step, max } = this.getProperties();
    const newValue = value + step;

    if (newValue < max) {
      this.setFormValue(newValue);
      return;
    }

    if (value < max) {
      this.setFormValue(max);
      return;
    }
  }

  protected decrease(): void {
    const { value, step, min } = this.getProperties();
    const newValue = value - step;

    if (newValue > min) {
      this.setFormValue(newValue);
      return;
    }

    if (value > min) {
      this.setFormValue(min);
      return;
    }
  }

  protected sliderChange(args: MatSliderChange): void {
    Number.isFinite(args.value) && this.setFormValue(args.value!);
  }

  private setFormValue(value: number): void {
    const rounded = value.toFixed(2);
    console.log('rounded', rounded, 'number', Number(rounded));
    this.formControl?.setValue(Number(rounded));
    this.formControl?.markAllAsTouched();
  }

  private getProperties() {
    const value = coerceNumberProperty(this.formControl?.value, 0);
    const step = coerceNumberProperty(this.props.step, 1);
    const min = coerceNumberProperty(this.props.min, 0);
    const max = coerceNumberProperty(this.props.max, 0);

    return { value, step, min, max };
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'slider',
          component: SliderComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
})
export class FormSliderModule {}
